import React from 'react'

import * as Sentry from '@sentry/react'
import {
  MeetingProvider as ChimeMeetingProvider,
  LocalVideoProvider,
  lightTheme,
} from 'amazon-chime-sdk-component-library-react'
import { Route, Routes } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'

import { Call } from './pages/Call'
import { Layout } from './pages/Layout'
import { SignIn } from './pages/SignIn'
import {
  AosTokenProvider,
  CallStatusProvider,
  MeetingProvider,
  TwilioWorkerProvider,
} from './providers'

Sentry.init({
  dsn: 'https://993fa3e0e876a648cadf6077b5a1bafe@o44447.ingest.us.sentry.io/4509721568018432',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  enabled: import.meta.env.PROD,
})

const App: React.FC = () => {
  return (
    <ThemeProvider theme={lightTheme}>
      <ChimeMeetingProvider>
        <LocalVideoProvider>
          <TwilioWorkerProvider>
            <AosTokenProvider>
              <MeetingProvider>
                <CallStatusProvider>
                  <Routes>
                    <Route element={<Layout />}>
                      <Route path="/" element={<Call />} />
                      <Route path="/sign-in" element={<SignIn />} />
                    </Route>
                  </Routes>
                </CallStatusProvider>
              </MeetingProvider>
            </AosTokenProvider>
          </TwilioWorkerProvider>
        </LocalVideoProvider>
      </ChimeMeetingProvider>
    </ThemeProvider>
  )
}

export default App
